// apps/web/src/components/payment-accounts/PaymentAccountsManager.tsx
// Payment account balance + transaction management.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { PaymentAccount } from '../../types/platform.js';

export function PaymentAccountsManager() {
  return (
    <ManagerPage
      title="Payment Accounts"
      listPath="/api/v1/payment-accounts"
      listKey="accounts"
      createLabel="New Account"
      className="payment-accounts-manager"
      renderItem={(raw) => {
        const a = raw as PaymentAccount;
        return (
          <div className="manager-card" key={a.id}>
            <h3>{a.accountType}</h3>
            <p className="status-badge">{a.status}</p>
            <p>Currency {a.currency ?? '—'} · Party {a.partyId?.slice(0, 8) ?? '—'}</p>
            <div className="actions">
              <button className="btn btn-secondary">Balance</button>
              <button className="btn btn-primary">Verify</button>
              <button className="btn btn-danger">Close</button>
            </div>
          </div>
        );
      }}
    />
  );
}